import { Helmet } from "react-helmet-async";
import PropTypes from "prop-types";

const Seo = (props) => {
  const { title } = props;

  const fullTitle = title ? title + " | XTrack" : "XTrack";

  return (
    <Helmet>
      <title>{fullTitle}</title>
    </Helmet>
  );
};

Seo.propTypes = {
  title: PropTypes.string,
};

export default Seo;
